import PropTypes from "prop-types";
import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import { payConsultation } from "../../../../utils/fetcher";
import { useDispatch, useSelector } from "react-redux";
import Alert from "@material-ui/lab/Alert";
import { translator } from "../../../../utils/i18n";

const currentYear = new Date().getFullYear();
const monthsArr = Array.from({ length: 12 }, (x, i) => {
  const month = i + 1;
  return month <= 9 ? "0" + month : month;
});
const yearsArr = Array.from({ length: 9 }, (_x, i) => currentYear + i);

export default function CForm({
  cardMonth,
  cardYear,
  onUpdateState,
  cardNumberRef,
  cardHolderRef,
  cardDateRef,
  onCardInputFocus,
  onCardInputBlur,
  cardCvv,
  children
}) {
  const [cardNumber, setCardNumber] = useState("");
  const dispatch = useDispatch();
  const pay = data => dispatch(payConsultation(data));
  const sum = useSelector(state => state.payment.sum);
  const message = useSelector(state => state.messageWithCode);
  const isLoading = useSelector(state => state.loader.isLoading);

  const handleFormChange = event => {
    const { name, value } = event.target;

    onUpdateState(name, value);
  };

  // TODO: We can improve the regex check with a better approach like in the card component.
  const onCardNumberChange = event => {
    let { value, name } = event.target;
    let cardNumber = value;
    value = value.replace(/\D/g, "");
    if (/^3[47]\d{0,13}$/.test(value)) {
      cardNumber = value
        .replace(/(\d{4})/, "$1 ")
        .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
    } else if (/^3(?:0[0-5]|[68]\d)\d{0,11}$/.test(value)) {
      // diner's club, 14 digits
      cardNumber = value
        .replace(/(\d{4})/, "$1 ")
        .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
    } else if (/^\d{0,16}$/.test(value)) {
      // regular cc number, 16 digits
      cardNumber = value
        .replace(/(\d{4})/, "$1 ")
        .replace(/(\d{4}) (\d{4})/, "$1 $2 ")
        .replace(/(\d{4}) (\d{4}) (\d{4})/, "$1 $2 $3 ");
    }

    setCardNumber(cardNumber.trimRight());
    onUpdateState(name, cardNumber);
  };

  const onCvvFocus = () => {
    onUpdateState("isCardFlipped", true);
  };

  const onCvvBlur = () => {
    onUpdateState("isCardFlipped", false);
  };

  const onSubmit = e => {
    e.preventDefault();
    pay({
      nom_carte: children.props.cardHolder,
      date_exp: `${cardMonth}/${cardYear}`,
      num_carte: cardNumber,
      cryptogramme: children.props.cardCvv,
      montant: sum
    });
  };

  const isValidForm = () => {
    if (
      children.props.cardHolder &&
      children.props.cardHolder !== "" &&
      cardMonth &&
      !isNaN(cardMonth) &&
      cardYear &&
      !isNaN(cardYear) &&
      cardNumber &&
      cardNumber !== "" &&
      children.props.cardCvv &&
      children.props.cardCvv !== ""
    ) {
      return false;
    }
    return true;
  };

  const getForm = () => {
    return (
      <div className="card-form">
        {isLoading && (
          <div className="wrap-circular-progress">
            <div className="la-ball-spin-fade-rotating la-2x primary">
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
            </div>
          </div>
        )}
        <div className="card-list">{children}</div>
        <div className="card-form__inner">
          <div className="card-input">
            <label htmlFor="cardNumber" className="card-input__label">
              {translator()._("W_NUMERO_CARTE")}
            </label>
            <input
              type="tel"
              name="cardNumber"
              className="card-input__input"
              autoComplete="off"
              onChange={onCardNumberChange}
              maxLength="19"
              ref={cardNumberRef}
              onFocus={e => onCardInputFocus(e, "cardNumber")}
              onBlur={onCardInputBlur}
              value={cardNumber}
              required={true}
            />
          </div>

          <div className="card-input">
            <label htmlFor="cardName" className="card-input__label">
              {translator()._("W_NOM_CARTE")}
            </label>
            <input
              type="text"
              className="card-input__input"
              autoComplete="off"
              name="cardHolder"
              onChange={handleFormChange}
              ref={cardHolderRef}
              onFocus={e => onCardInputFocus(e, "cardHolder")}
              onBlur={onCardInputBlur}
              required={true}
            />
          </div>

          <div className="card-form__row">
            <div className="card-form__col">
              <div className="card-form__group">
                <label htmlFor="cardMonth" className="card-input__label">
                  {translator()._("W_DATE_EXPIRATION")}
                </label>
                <select
                  className="card-input__input -select"
                  value={cardMonth}
                  name="cardMonth"
                  onChange={handleFormChange}
                  ref={cardDateRef}
                  onFocus={e => onCardInputFocus(e, "cardDate")}
                  onBlur={onCardInputBlur}
                  required={true}
                >
                  <option value="" disabled>
                    {translator()._("W_STEP4_FORMULAIRE_MOIS")}
                  </option>

                  {monthsArr.map((val, index) => (
                    <option key={index} value={val}>
                      {val}
                    </option>
                  ))}
                </select>
                <select
                  name="cardYear"
                  className="card-input__input -select"
                  value={cardYear}
                  onChange={handleFormChange}
                  onFocus={e => onCardInputFocus(e, "cardDate")}
                  onBlur={onCardInputBlur}
                  required={true}
                >
                  <option value="" disabled>
                    {translator()._("W_STEP4_FORMULAIRE_ANNEE")}
                  </option>

                  {yearsArr.map((val, index) => (
                    <option key={index} value={val}>
                      {val}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="card-form__col -cvv">
              <div className="card-input">
                <label htmlFor="cardCvv" className="card-input__label">
                  Code de vérification
                </label>
                <input
                  type="tel"
                  className="card-input__input"
                  maxLength="4"
                  autoComplete="off"
                  name="cardCvv"
                  onChange={handleFormChange}
                  onFocus={onCvvFocus}
                  onBlur={onCvvBlur}
                  value={cardCvv}
                  required={true}
                />
              </div>
            </div>
          </div>

          <div className="align-center">
            <div className="align-right mb-5">
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                disabled={isLoading || isValidForm()}
              >
                {translator()._("W_PAYER")} {sum} &euro;
              </Button>
            </div>
            {message && message.text && (
              <Alert severity={message.code === 1 ? "success" : "warning"}>
                {message.text}
              </Alert>
            )}
          </div>
        </div>
      </div>
    );
  };

  return <form onSubmit={onSubmit}>{getForm()}</form>;
}

CForm.propTypes = {
  cardCvv: PropTypes.any,
  cardDateRef: PropTypes.any,
  cardHolderRef: PropTypes.any,
  cardMonth: PropTypes.any,
  cardNumberRef: PropTypes.any,
  cardYear: PropTypes.any,
  children: PropTypes.shape({
    props: PropTypes.shape({
      cardCvv: PropTypes.string,
      cardHolder: PropTypes.string
    })
  }),
  onCardInputBlur: PropTypes.any,
  onCardInputFocus: PropTypes.func,
  onUpdateState: PropTypes.func
};
